import React, { useState } from 'react';
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs';

type ControlledInputValueUnionType = string | number | string[];

interface ControlledInputProps {
  id: string;
  label?: string;
  value: ControlledInputValueUnionType | undefined;
  onChange: (value: ControlledInputValueUnionType | undefined) => void;
  inputType: React.HTMLInputTypeAttribute;
}

export const ControlledInput: React.FC<ControlledInputProps> = ({ id, label, value, inputType, onChange }) => {
  const [localValue, setLocalValue] = useState<typeof value>(value);

  if (value !== localValue && document.activeElement?.id !== id) {
    setLocalValue(value);
  }

  const handleChange = (e: InputChangeEvent) => {
    setLocalValue(e.value);
  };

  const handleBlur = () => {
    if (localValue !== undefined) {
      onChange(localValue);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && localValue !== undefined) {
      onChange(localValue);
    }
  };

  return (
    <Input
      id={id}
      label={label}
      type={inputType}
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
    />
  );
};
